import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const NetworkingFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="What’s the difference between a basic setup and a structured network?">
                  <p>A basic setup:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Works temporarily</span>
                    </li>
                    <li>
                      <span>Struggles under load</span>
                    </li>
                    <li>
                      <span>Has no scalability</span>
                    </li>
                  </ul>
                  <p>A structured network:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Is stable and organized</span>
                    </li>
                    <li>
                      <span>Handles growth</span>
                    </li>
                    <li>
                      <span>Supports business operations</span>
                    </li>
                  </ul>
                  <p>
                    You move from trial-and-error to engineered reliability.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Is this solution suitable for small businesses or only large ones?">
                  <p>Both.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Small setups → efficient and scalable</span>
                    </li>
                    <li>
                      <span>Large setups → structured and robust</span>
                    </li>
                  </ul>
                  <p>The solution is tailored to your size and needs.</p>
                </FaqCardList>
                <FaqCardList faq="Why should I invest in a professionally designed network?">
                  <p>Because your network affects everything:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Productivity</span>
                    </li>
                    <li>
                      <span>Communication</span>
                    </li>
                    <li>
                      <span>System performance</span>
                    </li>
                    <li>
                      <span>Customer experience</span>
                    </li>
                  </ul>
                  <p>
                    A properly designed network saves time, reduces frustration,
                    and supports growth.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Why is my current network slow or unreliable?">
                  <p>
                    Most network issues come from poor design, not just internet
                    speed. Common causes include:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Weak or poorly placed WiFi devices</span>
                    </li>
                    <li>
                      <span>Low-quality or disorganized cabling</span>
                    </li>
                    <li>
                      <span>Too many users on an unstructured network</span>
                    </li>
                    <li>
                      <span>No bandwidth control or prioritization</span>
                    </li>
                  </ul>
                  <p>
                    A properly designed network solves these issues at the
                    root—not temporarily.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will a professional network setup improve my internet speed?">
                  <p>
                    Yes—but more importantly, it improves how your internet is
                    used. We:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Optimize distribution across users</span>
                    </li>
                    <li>
                      <span>Reduce congestion</span>
                    </li>
                    <li>
                      <span>Prioritize critical applications</span>
                    </li>
                  </ul>
                  <p>
                    The result is a network that feels faster, more stable, and
                    consistent.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will WiFi cover all areas without weak signals?">
                  <p>Yes. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Plan coverage zones</span>
                    </li>
                    <li>
                      <span>Strategically place access points</span>
                    </li>
                    <li>
                      <span>Eliminate dead zones</span>
                    </li>
                  </ul>
                  <p>
                    You get strong, consistent signal across your entire space.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if I have multiple floors or a large space?">
                  <p>That’s factored into the design. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Multi-access point systems</span>
                    </li>
                    <li>
                      <span>Floor-by-floor coverage planning</span>
                    </li>
                    <li>
                      <span>Load balancing</span>
                    </li>
                  </ul>
                  <p>
                    Your network works reliably across large or complex
                    environments.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can the network handle many users at the same time?">
                  <p>Yes. We design for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>User load capacity</span>
                    </li>
                    <li>
                      <span>Device density</span>
                    </li>
                    <li>
                      <span>Traffic distribution</span>
                    </li>
                  </ul>
                  <p>
                    Your network remains stable even with many users connected
                    simultaneously.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will my business systems work better after this setup?">
                  <p>Yes. A strong network improves:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>System performance</span>
                    </li>
                    <li>
                      <span>Communication tools</span>
                    </li>
                    <li>
                      <span>Cloud applications</span>
                    </li>
                    <li>
                      <span>POS and operational systems</span>
                    </li>
                  </ul>
                  <p>Everything runs faster, smoother, and more reliably.</p>
                </FaqCardList>
                <FaqCardList faq="Is the network secure from unauthorized access?">
                  <p>Yes. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Secure WiFi encryption</span>
                    </li>
                    <li>
                      <span>Access controls</span>
                    </li>
                    <li>
                      <span>Network segmentation</span>
                    </li>
                  </ul>
                  <p>
                    Your network is protected from unauthorized users and
                    internal misuse.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I control how users access the network?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Restrict access by user or department</span>
                    </li>
                    <li>
                      <span>Create guest networks</span>
                    </li>
                    <li>
                      <span>Control bandwidth usage</span>
                    </li>
                  </ul>
                  <p>
                    You maintain full control over network access and usage.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do I need special equipment for a good network?">
                  <p>Not necessarily—but the right equipment matters. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Recommend suitable devices</span>
                    </li>
                    <li>
                      <span>Avoid underpowered setups</span>
                    </li>
                    <li>
                      <span>Ensure compatibility</span>
                    </li>
                  </ul>
                  <p>
                    You get the right tools for your specific needs—not overkill
                    or underperformance.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the installation disrupt my business operations?">
                  <p>No. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Plan installations carefully</span>
                    </li>
                    <li>
                      <span>Work in phases if needed</span>
                    </li>
                    <li>
                      <span>Minimize downtime</span>
                    </li>
                  </ul>
                  <p>Your operations continue with little to no disruption.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to install a network?">
                  <p>It depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Size of the space</span>
                    </li>
                    <li>
                      <span>Complexity of the setup</span>
                    </li>
                    <li>
                      <span>Cabling requirements</span>
                    </li>
                  </ul>
                  <p>
                    Timelines are clearly defined before starting, so you know
                    what to expect.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can the network be expanded later?">
                  <p>Yes. Your system is designed to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Add more users</span>
                    </li>
                    <li>
                      <span>Add more devices</span>
                    </li>
                    <li>
                      <span>Extend coverage</span>
                    </li>
                  </ul>
                  <p>You can scale without rebuilding your entire network.</p>
                </FaqCardList>
                <FaqCardList faq="Will I need ongoing maintenance?">
                  <p>Minimal, but important. We recommend:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Periodic checks</span>
                    </li>
                    <li>
                      <span>Performance monitoring</span>
                    </li>
                    <li>
                      <span>Occasional updates</span>
                    </li>
                  </ul>
                  <p>
                    This ensures your network stays fast and reliable long-term.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What happens if something stops working?">
                  <p>Support is available. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Diagnose the issue</span>
                    </li>
                    <li>
                      <span>Fix faults</span>
                    </li>
                    <li>
                      <span>Restore performance</span>
                    </li>
                  </ul>
                  <p>You are not left dealing with network issues alone.</p>
                </FaqCardList>
                <FaqCardList faq="Can I monitor my network performance?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Track usage</span>
                    </li>
                    <li>
                      <span>Monitor connected devices</span>
                    </li>
                    <li>
                      <span>Identify issues</span>
                    </li>
                  </ul>
                  <p>You get to see into how your network is being used.</p>
                </FaqCardList>
                <FaqCardList faq="Will this work with my existing systems and devices?">
                  <p>Yes. We ensure compatibility with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Computers and laptops</span>
                    </li>
                    <li>
                      <span>Printers and shared devices</span>
                    </li>
                    <li>
                      <span>CCTV and access control</span>
                    </li>
                    <li>
                      <span>Business systems and software</span>
                    </li>
                  </ul>
                  <p>Everything integrates into one connected environment.</p>
                </FaqCardList>
                <FaqCardList faq="Do I need internet for the network to function?">
                  <p>Not entirely.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Local network (LAN) works without internet</span>
                    </li>
                    <li>
                      <span>Internet is required for external access</span>
                    </li>
                  </ul>
                  <p>
                    Your internal systems can still function even if internet is
                    down.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will a professional network reduce downtime and connection issues?">
                  <p>Yes. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Eliminate weak points</span>
                    </li>
                    <li>
                      <span>Optimize performance</span>
                    </li>
                    <li>
                      <span>Build redundancy where needed</span>
                    </li>
                  </ul>
                  <p>
                    You experience fewer interruptions and more consistent
                    uptime.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if my internet provider is the problem?">
                  <p>We help you identify that. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Test performance</span>
                    </li>
                    <li>
                      <span>Diagnose bottlenecks</span>
                    </li>
                    <li>
                      <span>Recommend improvements</span>
                    </li>
                  </ul>
                  <p>
                    You get clarity on whether the issue is your network or your
                    ISP.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I understand how to use and manage the network?">
                  <p>Yes. You will receive:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Basic training</span>
                    </li>
                    <li>
                      <span>Access guidance</span>
                    </li>
                    <li>
                      <span>Support when needed</span>
                    </li>
                  </ul>
                  <p>
                    You remain in control without needing deep technical
                    knowledge.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What is the final result after setup?Will I understand how to use and manage the network?">
                  <p>You get:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Fast and stable connectivity</span>
                    </li>
                    <li>
                      <span>Reliable WiFi coverage</span>
                    </li>
                    <li>
                      <span>Secure network access</span>
                    </li>
                    <li>
                      <span>Efficient system performance</span>
                    </li>
                  </ul>
                  <p>
                    Most importantly, you get a network that supports your
                    business instead of slowing it down.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What makes your networking solution different?">
                  <p>We don’t just install routers and cables. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Plan strategically</span>
                    </li>
                    <li>
                      <span>Design structured systems</span>
                    </li>
                    <li>
                      <span>Optimize for real-world usage</span>
                    </li>
                  </ul>
                  <p>
                    You get a reliable network infrastructure—not just a setup.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will my network be properly organized and easy to manage physically?">
                  <p>Yes. We ensure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Structured cabling</span>
                    </li>
                    <li>
                      <span>Clear labeling</span>
                    </li>
                    <li>
                      <span>Organized rack setups</span>
                    </li>
                  </ul>
                  <p>
                    Your network is clean, professional, and easy to
                    maintain—not messy or confusing.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I receive documentation of the network setup?">
                  <p>Yes. You receive:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Network layout</span>
                    </li>
                    <li>
                      <span>Device configurations</span>
                    </li>
                    <li>
                      <span>Access details</span>
                    </li>
                  </ul>
                  <p>
                    You have full visibility and control even after
                    installation.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can the network handle high-traffic environments like offices or schools?">
                  <p>Yes. We design for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>High user density</span>
                    </li>
                    <li>
                      <span>Multiple devices</span>
                    </li>
                    <li>
                      <span>Continuous usage</span>
                    </li>
                  </ul>
                  <p>
                    Your network remains stable and responsive even under heavy
                    demand.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I control which users or systems get priority on the network?">
                  <p>Yes. We configure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Bandwidth allocation</span>
                    </li>
                    <li>
                      <span>Traffic prioritization</span>
                    </li>
                  </ul>
                  <p>Critical systems always get the performance they need.</p>
                </FaqCardList>
                <FaqCardList faq="What happens if the internet connection fails?">
                  <p>
                    Your internal network will still function. For advanced
                    setups, we can implement:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Backup connections</span>
                    </li>
                    <li>
                      <span>Automatic failover</span>
                    </li>
                  </ul>
                  <p>Your operations remain less affected during outages.</p>
                </FaqCardList>
                <FaqCardList faq="Is the system designed for long-term use or just immediate needs?">
                  <p>It is designed for both. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Plan for current usage</span>
                    </li>
                    <li>
                      <span>Build for future expansion</span>
                    </li>
                  </ul>
                  <p>
                    You get a network that serves you now and grows with you
                    over time.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin setups</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkingFaqsBody;
